import React, { useEffect, useRef } from "react";
import { useCore } from "../hooks";
import { Dropdown } from "./form/Dropdown.tsx";

export const CheckoutDropdown: React.FC = () => {
  const { checkouts, selectedCheckoutId, selectedDetailCheckoutId, setSelectedDetailCheckoutId } = useCore()

  const didInitRef = useRef(false)
  useEffect(() => {
    if (!didInitRef.current && selectedCheckoutId) {
      setSelectedDetailCheckoutId(selectedCheckoutId)
      didInitRef.current = true
    }
  }, [selectedCheckoutId, setSelectedDetailCheckoutId])

  return (
    <Dropdown
      label={'Pokladna'}
      icon={'cash-register'}
      options={checkouts?.map(c => ({ label: c.name, value: c.id }))}
      value={selectedDetailCheckoutId}
      onChange={val => setSelectedDetailCheckoutId(val)}
    />
  )
}
